import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'otb-form-builder-select-numeric',
    templateUrl: './select-numeric.component.html',
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectNumericComponent),
            multi: true,
        },
    ],
})
export class SelectNumericComponent implements OnInit, ControlValueAccessor {
    @Input() id: string | null = null;
    @Input() name: string = '';
    @Input() label: string = '';
    @Input() items: unknown[] = [];
    @Input() helpText: string | null = null;
    @Input() required: boolean = true;
    @Input() clearable: boolean = false;
    @Input() defaultValue: unknown;

    selectValue: any;
    disabled = false;

    private notifyChange: (value: unknown) => void = () => {};
    private notifyTouched: () => void = () => {};

    ngOnInit(): void {
        if (this.selectValue === undefined && this.defaultValue !== null) {
            this.selectValue = this.defaultValue;
        }

        if (this.id === null) {
            this.id = this.name;
        }
    }

    updateValue(): void {
        this.value = this.selectValue;
        this.notifyChange(this.selectValue);
        this.notifyTouched();
    }

    @Input()
    get value(): number {
        return this.selectValue;
    }

    @Output() valueChange = new EventEmitter<number>();
    set value(val) {
        this.selectValue = val;
        this.valueChange.emit(this.selectValue);
    }

    writeValue(value: unknown): void {
        this.selectValue = value;
    }

    registerOnChange(fn: (value: unknown) => void): void {
        this.notifyChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.notifyTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
